.icon {
  flex-shrink: 0;
}
